var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRelative = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.739 1.389C14.597.497 14.161 0 13.178 0h-9.57c-.983 0-1.418.497-1.56 1.389h12.691zM14.293 20c1.754 0 2.788-1.024 2.788-3.02V5.95c0-1.997-1.034-3.02-3.062-3.02H3.061C1.034 2.93 0 3.943 0 5.95v11.03C0 18.985 1.034 20 3.061 20h11.232zm-6.741-1.662H6.336c-.558-.75.1-2.707 1.246-3.61-.506-.374-1.226-.587-2.128-.587-1.967 0-3.406 1.226-3.781 2.524V6.062c0-.973.517-1.47 1.45-1.47h10.835c.923 0 1.45.497 1.45 1.47v9.843c-.7-.943-2.098-1.744-3.882-1.744-2.727 0-4.44 1.875-4.44 3.457 0 .466.283.71.466.72zm3.974-5.312c1.145 0 2.108-1.014 2.108-2.332 0-1.287-.973-2.26-2.108-2.26-1.126 0-2.119.993-2.109 2.28 0 1.298.973 2.312 2.109 2.312zm-6.062.132c.993 0 1.835-.882 1.835-2.038 0-1.125-.852-1.966-1.835-1.966-.984 0-1.845.851-1.845 1.976 0 1.146.851 2.028 1.845 2.028z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRelative, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/_relative.9169c0c2.svg";
export { ForwardRef as ReactComponent };